import React, { useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import AwpValidationErrorModal from '@awp/components/Common/AwpValidationErrorModal';
import { useVMSControlContext } from './VMSControlContext'; // Adjust the import path as needed
import VMSControlStationGroup from './VMSControlStationGroup';
import { Crud } from '@awp/shared/Crud'; // Adjust the import path as needed

/**
 * VMSControlList Component
 * Renders a list of Variable Message Sign (VMS) control groups.
 *
 * @returns {JSX.Element} - The rendered VMSControlList component.
 */
const VMSControlList = () => {
  const { VMSData, formMode } = useVMSControlContext();
  const [entityErrors, setEntityErrors] = useState(null);

  const crud = new Crud('Control Variable Message Signs', formMode);

  /**
   * Splits an array into chunks of a specified size.
   *
   * @param {Array} array - The array to be split into chunks.
   * @param {number} chunkSize - The size of each chunk.
   * @returns {Array[]} An array of chunks.
   */
  const chunkArray = (array, chunkSize) => {
    const chunks = [];
    for (let i = 0; i < array.length; i += chunkSize) {
      chunks.push(array.slice(i, i + chunkSize));
    }
    return chunks;
  };

  // Generate layout by splitting VMSData into rows of 2 items each
  const layout = chunkArray(VMSData, 2);

  return (
    <>
      <div className="d-flex">{crud.getHeader()}</div>
      <Container className="mb-3">
        {layout.map((row, rowIndex) => (
          <Row key={rowIndex}>
            {row.map((group, colIndex) => (
              <Col key={colIndex} xs={12} md={6} className="mb-4">
                <VMSControlStationGroup locationName={group.Location} vmsSigns={group.vmsSigns} />
              </Col>
            ))}
          </Row>
        ))}
      </Container>
      <AwpValidationErrorModal setErrors={setEntityErrors} errors={entityErrors} />
    </>
  );
};

export default VMSControlList;
